// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__WBe7C","switch":"Settings_switch__7we+8","circles":"Settings_circles__94DM8"};